/* There & Then storefront scripts: place search, places nearby, the map finder (with impossible answers ruled
   out), edition tabs, the gazetteer page, and filling place and series headers from the gazetteer.
   No dependencies. Everything degrades to plain links when scripts are off. */
(function () {
  'use strict';
  var D = {};
  try { D = JSON.parse(document.getElementById('tt-data').textContent); } catch (e) { return; }
  var SERIES = D.series || [], SERIES_BY = {};
  SERIES.forEach(function (s) { SERIES_BY[s.key] = s; });
  var LIVE = new Set(D.liveTags || []);
  var ALL = D.collectionAll || '/collections/all';
  var SOON = D.comingSoon || 'Coming soon';
  var COUNTRY = { england: 'England', wales: 'Wales', scotland: 'Scotland' };
  var ERAS = [
    { key: '1600s', label: '1600s', from: 1600, to: 1699 }, { key: '1700s', label: '1700s', from: 1700, to: 1799 },
    { key: '1800-49', label: '1800–49', from: 1800, to: 1849 }, { key: '1850-99', label: '1850–99', from: 1850, to: 1899 },
    { key: '1900-29', label: '1900–29', from: 1900, to: 1929 }, { key: '1930-49', label: '1930s–40s', from: 1930, to: 1949 },
    { key: '1950s', label: '1950s', from: 1950, to: 1961 }];
  var OBJECTS = [
    { key: 'print', label: 'A print' }, { key: 'framed', label: 'Framed' }, { key: 'hanger', label: 'On a hanger' },
    { key: 'coaster', label: 'Coasters' }, { key: 'mug', label: 'A mug' },
    { key: 'calendar', label: 'A calendar' }, { key: 'postcard', label: 'Postcards' }];

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function slugify(s) { return String(s).toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  var URLS = D.urls || {};
  /* A real collection (e.g. /collections/hoylake) when the shop has one; otherwise the tag page. */
  var PLACES_PAGE = D.placesPage || '/pages/places';
  /* Shopify sends a tag page with no products back to /collections/all, so places not in the shop yet
     get their "coming soon" panel on the gazetteer page instead. */
  function tagUrl(t, extra) {
    if (URLS[t]) return URLS[t] + (extra ? '/' + extra : '');
    if (!LIVE.has(t)) return t.indexOf('place-') === 0 ? PLACES_PAGE + '?place=' + encodeURIComponent(t.slice(6)) : ALL;
    return ALL + '/' + t + (extra ? '+' + extra : '');
  }
  function placeUrl(slug, extra) { return tagUrl('place-' + slug, extra); }
  function miles(a, b) {
    var R = 3958.8, r = Math.PI / 180, dLat = (b.lat - a.lat) * r, dLon = (b.lon - a.lon) * r;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  /* ---------- data */
  var PRODUCTS = [];
  $$('script[data-tt-products]').forEach(function (s) { try { PRODUCTS = PRODUCTS.concat(JSON.parse(s.textContent)); } catch (e) {} });
  var seen = {}; PRODUCTS = PRODUCTS.filter(function (p) { if (seen[p.url]) return false; seen[p.url] = 1; return true; });
  function tag(p, prefix) { for (var i = 0; i < p.tags.length; i++) if (p.tags[i].indexOf(prefix) === 0) return p.tags[i].slice(prefix.length); return ''; }

  var placesP = null;
  function places() {
    if (placesP) return placesP;
    placesP = fetch(D.places).then(function (r) { return r.json(); }).catch(function () { return { places: [] }; }).then(function (j) {
      var list = (j.places || []).slice(), by = {};
      list.forEach(function (p) { by[p.slug] = p; });
      // places that have products but are missing from the gazetteer still appear, named from the product
      PRODUCTS.forEach(function (p) {
        var s = tag(p, 'place-'); if (!s || by[s]) return;
        by[s] = { slug: s, name: p.title.split(/\s+historic map\b/i)[0].split(/[,·–—]/)[0].trim(), county: '', country: tag(p, 'country-'), lat: null, lon: null, group: '' };
        list.push(by[s]);
      });
      list.forEach(function (p) {
        p.live = LIVE.has('place-' + p.slug);
        p.products = PRODUCTS.filter(function (q) { return q.tags.indexOf('place-' + p.slug) > -1; });
      });
      // Places a sheet also shows (approved in Atlas): "Bootle" finds the Liverpool map
      var aliases = [], named = {};
      list.forEach(function (p) { named[p.name.toLowerCase()] = p; });
      PRODUCTS.forEach(function (q) {
        var host = by[tag(q, 'place-')]; if (!host) return;
        (q.also || []).forEach(function (n) {
          var k = String(n).toLowerCase(), g = named[k];
          if (g && g.live) return;
          if (g) { if (!g.onSheet) g.onSheet = host; return; }
          if (aliases.some(function (a) { return a.name.toLowerCase() === k; })) return;
          aliases.push({ slug: host.slug, name: String(n), county: '', live: true, onSheet: host, products: host.products });
        });
      });
      return { list: list, by: by, aliases: aliases };
    });
    return placesP;
  }

  /* ---------- place search (hero, finder) */
  function setupSearch(box) {
    var input = $('input[type="search"], input[type="text"]', box), list = $('.tt-suggest', box);
    if (!input || !list) return;
    var finder = box.hasAttribute('data-tt-finder-place'), items = [], at = -1;
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); at = -1; }
    function render(q) {
      places().then(function (P) {
        var n = q.trim().toLowerCase(); if (!n) { close(); return; }
        items = P.list.concat(P.aliases || []).filter(function (p) { return p.name.toLowerCase().indexOf(n) > -1 || (p.county || '').toLowerCase().indexOf(n) === 0; })
          .sort(function (a, b) {
            var as = a.name.toLowerCase().indexOf(n) === 0 ? 0 : 1, bs = b.name.toLowerCase().indexOf(n) === 0 ? 0 : 1;
            return (as - bs) || ((b.live ? 1 : 0) - (a.live ? 1 : 0)) || a.name.localeCompare(b.name);
          }).slice(0, 8);
        if (!items.length) {
          list.innerHTML = '<li><a href="' + esc((D.search || '/search') + '?q=' + encodeURIComponent(q)) + '" role="option" id="' + list.id + '-0"><span>Search the shop for “' + esc(q) + '”</span></a></li>';
        } else {
          list.innerHTML = items.map(function (p, i) {
            var meta = p.onSheet ? 'On the ' + esc(p.onSheet.name) + ' map' : p.live ? 'In the shop' : '<span class="tt-soon">' + esc(SOON) + '</span>';
            return '<li><a role="option" id="' + list.id + '-' + i + '" data-i="' + i + '" href="' + esc(placeUrl(p.onSheet ? p.onSheet.slug : p.slug)) + '"><span>' + esc(p.name) +
              (p.county ? ' <span class="tt-suggest__meta">' + esc(p.county) + '</span>' : '') + '</span><span class="tt-suggest__meta">' + meta + '</span></a></li>';
          }).join('');
        }
        list.hidden = false; input.setAttribute('aria-expanded', 'true'); at = -1;
      });
    }
    function pick(i) {
      var p = items[i]; if (!p) return false;
      if (finder) { if (p.onSheet) p = p.onSheet; input.value = p.name; close(); box.dispatchEvent(new CustomEvent('tt:place', { detail: p, bubbles: true })); return true; }
      return false;
    }
    input.addEventListener('input', function () { render(input.value); if (finder && !input.value.trim()) box.dispatchEvent(new CustomEvent('tt:place', { detail: null, bubbles: true })); });
    input.addEventListener('keydown', function (e) {
      var opts = $$('[role="option"]', list); if (list.hidden || !opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); at = (at + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === at ? 'true' : 'false'); });
        input.setAttribute('aria-activedescendant', opts[at].id);
      } else if (e.key === 'Enter' && at > -1) {
        e.preventDefault(); if (!pick(at)) window.location.href = opts[at].href;
      } else if (e.key === 'Escape') { close(); }
    });
    list.addEventListener('click', function (e) { var a = e.target.closest('a[data-i]'); if (a && finder) { e.preventDefault(); pick(+a.dataset.i); } });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
  }

  /* ---------- cards */
  function card(p, dist) {
    var img = p.products.length && p.products[0].img;
    var visual = img ? '<img src="' + esc(img) + '" alt="' + esc(p.name) + ' on an old map" loading="lazy">'
      : '<span class="tt-soon-tile"><span class="tt-soon-tile__name">' + esc(p.name) + '</span><span class="tt-soon-tile__tag">' + esc(SOON) + '</span></span>';
    var note = p.live ? (p.products.length + (p.products.length === 1 ? ' map' : ' maps') + (p.county ? ', ' + p.county : ''))
      : (p.county || COUNTRY[p.country] || '');
    return '<a class="tt-place-card" href="' + esc(placeUrl(p.slug)) + '"><span class="tt-place-card__img">' + visual + '</span>' +
      '<span class="tt-place-card__row"><span class="tt-place-card__name">' + esc(p.name) + '</span>' +
      (dist != null ? '<span class="tt-place-card__dist">' + (dist < 1 ? 'HERE' : Math.round(dist) + ' MI') + '</span>' : '') + '</span>' +
      '<span class="tt-place-card__note">' + esc(note) + '</span></a>';
  }

  /* ---------- places nearby */
  function setupNear(el) {
    var grid = $('[data-tt-near-grid]', el), status = $('[data-tt-near-status]', el), baseEl = $('[data-tt-near-base]', el);
    var count = +el.dataset.count || 6, liveFirst = el.dataset.liveFirst === 'true';
    function draw(origin) {
      places().then(function (P) {
        var list = P.list.filter(function (p) { return p.lat != null; }).map(function (p) { return { p: p, d: miles(origin, p) }; })
          .sort(function (a, b) { return a.d - b.d; });
        var near = list.slice(0, Math.max(count * 3, 12));
        if (liveFirst) near.sort(function (a, b) { return ((b.p.live ? 1 : 0) - (a.p.live ? 1 : 0)) || (a.d - b.d); });
        grid.innerHTML = near.slice(0, count).map(function (x) { return card(x.p, x.d); }).join('');
      });
    }
    draw({ lat: parseFloat(el.dataset.lat), lon: parseFloat(el.dataset.lon) });
    var btn = $('[data-tt-near-locate]', el);
    if (!('geolocation' in navigator)) { btn.hidden = true; return; }
    btn.addEventListener('click', function () {
      status.textContent = ' · finding you…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        status.textContent = ''; baseEl.textContent = 'you';
        draw({ lat: pos.coords.latitude, lon: pos.coords.longitude });   // used here only, never stored or sent
      }, function () { status.textContent = ' · location not shared'; }, { maximumAge: 600000, timeout: 10000 });
    });
  }

  /* ---------- tabs */
  function setupTabs(root) {
    var tabs = $$('[role="tab"]', root);
    function on(t) {
      tabs.forEach(function (x) {
        var sel = x === t; x.setAttribute('aria-selected', sel ? 'true' : 'false'); x.tabIndex = sel ? 0 : -1;
        var panel = document.getElementById(x.getAttribute('aria-controls')); if (panel) panel.hidden = !sel;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { on(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return;
        e.preventDefault(); var n = tabs[(i + k + tabs.length) % tabs.length]; on(n); n.focus();
      });
    });
  }

  /* ---------- series text: dates, notes, labels */
  function fillSeries() {
    $$('[data-tt-series-dates]').forEach(function (el) { var s = SERIES_BY[el.dataset.ttSeriesDates]; if (s && !el.textContent.trim()) el.textContent = s.from === s.to ? String(s.from) : s.from + '–' + s.to; });
    $$('[data-tt-series-note]').forEach(function (el) { var s = SERIES_BY[el.dataset.ttSeriesNote]; if (s && !el.textContent.trim()) el.textContent = s.note; });
    $$('[data-tt-series-label]').forEach(function (el) { var s = SERIES_BY[el.dataset.ttSeriesLabel]; if (s) el.textContent = s.label; });
  }

  /* ---------- place header: name and county from the gazetteer */
  function fillPlaceHead(el) {
    places().then(function (P) {
      var p = P.by[el.dataset.slug]; if (!p) return;
      $$('[data-tt-place-name]', el).forEach(function (n) { n.textContent = n.tagName === 'H1' ? p.name.toUpperCase() : p.name; });
      var c = $('[data-tt-crumb-county]', el);
      if (c && !c.textContent.trim() && p.county) { c.textContent = p.county; c.insertAdjacentHTML('afterend', '<span aria-hidden="true">›</span>'); }
      var k = $('[data-tt-place-kicker]', el);
      if (k && p.county && /On the old maps/.test(k.textContent)) k.textContent = p.county + (COUNTRY[p.country] ? ' · ' + COUNTRY[p.country] : '');
      $$('.tt-soon__title', el).forEach(function (t) { t.textContent = 'We haven’t printed ' + p.name + ' yet.'; });
      var st = $('[data-tt-soon-text]', el);
      if (st) st.textContent = 'The old sheets are being worked through one place at a time. Leave your email and we’ll tell you the day ' + p.name + ' arrives, on whichever map comes first.';
      if (document.title.indexOf(p.name) < 0 && el.querySelector('[data-tt-soon]')) document.title = p.name + ' on old maps: coming soon';
    });
  }

  /* ---------- the finder: rule out what cannot exist */
  function overlap(a0, a1, b0, b1) { return a0 <= b1 && b0 <= a1; }
  function seriesFits(s, st) {
    if (st.series && st.series !== s.key) return false;
    var countries = st.country ? [st.country] : Object.keys(s.cover);
    return countries.some(function (c) {
      var r = s.cover[c]; if (!r) return false;
      if (!st.era) return true;
      var e = ERAS.filter(function (x) { return x.key === st.era; })[0];
      return overlap(r[0], r[1], e.from, e.to);
    });
  }
  function possible(st) { return SERIES.some(function (s) { return seriesFits(s, st); }); }
  function reason(kind, key, st) {
    if (kind === 'series') {
      var s = SERIES_BY[key], where = Object.keys(s.cover).map(function (c) { return COUNTRY[c]; }).join(' and ');
      if (st.country && !s.cover[st.country]) return s.short + ' covers ' + where + ' only.';
      return s.short + ' dates from ' + (s.from === s.to ? s.from : s.from + '–' + s.to) + '.';
    }
    if (kind === 'era') {
      var e = ERAS.filter(function (x) { return x.key === key; })[0];
      if (st.series) return SERIES_BY[st.series].short + ' was not made in the ' + e.label + '.';
      return 'No map we know of covers ' + (COUNTRY[st.country] || 'that place') + ' in the ' + e.label + '.';
    }
    return '';
  }
  function setupFinder(root) {
    var st = { place: null, country: '', era: '', series: '', object: '' }, why = $('[data-tt-finder-why]', root), go = $('[data-tt-finder-go]', root);
    var groups = { era: $('[data-tt-facet="era"]', root), series: $('[data-tt-facet="series"]', root), object: $('[data-tt-facet="object"]', root) };
    groups.era.innerHTML = ERAS.map(function (e) { return '<button type="button" class="tt-chip" aria-pressed="false" data-k="' + e.key + '">' + e.label + '</button>'; }).join('');
    groups.series.innerHTML = SERIES.map(function (s) { return '<button type="button" class="tt-chip tt-face--' + s.face + '" style="font-size:1.4rem" aria-pressed="false" data-k="' + s.key + '">' + esc(s.short) + '</button>'; }).join('');
    groups.object.innerHTML = OBJECTS.map(function (o) { return '<button type="button" class="tt-chip" aria-pressed="false" data-k="' + o.key + '">' + o.label + '</button>'; }).join('');
    var note = '';
    function update() {
      ['era', 'series'].forEach(function (kind) {
        $$('.tt-chip', groups[kind]).forEach(function (b) {
          var k = b.dataset.k, test = Object.assign({}, st); test[kind] = k;
          var ok = possible(test);
          b.disabled = !ok && st[kind] !== k;
          b.title = b.disabled ? reason(kind, k, st) : '';
          b.setAttribute('aria-pressed', st[kind] === k ? 'true' : 'false');
        });
      });
      $$('.tt-chip', groups.object).forEach(function (b) { b.setAttribute('aria-pressed', st.object === b.dataset.k ? 'true' : 'false'); });
      // what the link can carry: place, series (or the only series that fits), object
      var fits = SERIES.filter(function (s) { return seriesFits(s, st); });
      var tags = [];
      if (st.series) tags.push('series-' + st.series); else if (st.era && fits.length === 1) tags.push('series-' + fits[0].key);
      if (st.object) tags.push('object-' + st.object);
      var href = st.place ? placeUrl(st.place.slug, tags.join('+')) : (tags.length ? tagUrl(tags[0], tags.slice(1).join('+')) : ALL);
      go.href = href;
      // what is in the shop now
      var now = PRODUCTS.filter(function (p) {
        if (st.place && p.tags.indexOf('place-' + st.place.slug) < 0) return false;
        if (st.object && p.tags.indexOf('object-' + st.object) < 0) return false;
        var s = tag(p, 'series-'); if (st.series && s !== st.series) return false;
        if (st.era) { var y = +tag(p, 'year-'), e = ERAS.filter(function (x) { return x.key === st.era; })[0]; if (y && (y < e.from || y > e.to)) return false; if (!y && s && SERIES_BY[s] && !overlap(SERIES_BY[s].from, SERIES_BY[s].to, e.from, e.to)) return false; }
        return true;
      }).length;
      var any = st.place || st.era || st.series || st.object;
      var msg = note || (!any ? 'Choose any one to begin.' :
        now ? now + (now === 1 ? ' map is' : ' maps are') + ' in the shop now.' :
        'Nothing in the shop for that yet. Follow the link to ask to hear when it arrives.');
      var out = $$('.tt-chip:disabled', groups.series).map(function (b) { return b.textContent; });
      if (out.length && (st.place || st.era)) msg += ' Not drawn' + (st.place ? ' for ' + st.place.name : '') + (st.era ? ' in the ' + ERAS.filter(function (x) { return x.key === st.era; })[0].label : '') + ': ' + out.join(', ') + '.';
      why.textContent = msg; note = '';
      go.textContent = now ? 'Show me the maps' : (any ? 'See what’s coming' : 'Show me the maps');
    }
    function choose(kind, k) {
      st[kind] = st[kind] === k ? '' : k;   // impossible chips are disabled, so a choice never contradicts another
      update();
    }
    Object.keys(groups).forEach(function (kind) {
      groups[kind].addEventListener('click', function (e) { var b = e.target.closest('.tt-chip'); if (b && !b.disabled) choose(kind, b.dataset.k); });
    });
    root.addEventListener('tt:place', function (e) {
      st.place = e.detail; st.country = e.detail ? (e.detail.country || '') : '';
      ['series', 'era'].forEach(function (k) { if (st[k] && !possible(st)) { note = 'Cleared ‘' + (k === 'series' ? SERIES_BY[st.series].short : st.era) + '’: not drawn for ' + e.detail.name + '.'; st[k] = ''; } });
      update();
    });
    update();
  }

  /* ---------- gazetteer page */
  function setupGazetteer(root) {
    var out = $('[data-tt-gaz-out]', root), q = $('[data-tt-gaz-q]', root), count = $('[data-tt-gaz-count]', root), show = 'all';
    // ?place=<slug>: the "coming soon" panel for a place not in the shop yet
    var soon = $('[data-tt-gaz-soon]', root), want = new URLSearchParams(location.search).get('place');
    var KEY = 'tt-soon-place';
    if (!want && /customer_posted=true/.test(location.search)) { try { want = sessionStorage.getItem(KEY); } catch (e) {} }
    if (soon && want) places().then(function (P) {
      var p = P.by[want] || { slug: want, name: want.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }), county: '' };
      if (p.live) { window.location.replace(placeUrl(p.slug)); return; }
      $$('[data-tt-gaz-soon-name]', soon).forEach(function (e) { e.textContent = p.name.toUpperCase(); });
      $$('[data-tt-gaz-soon-name2]', soon).forEach(function (e) { e.textContent = p.name; });
      $('[data-tt-gaz-soon-county]', soon).textContent = [p.county, COUNTRY[p.country]].filter(Boolean).join(' · ');
      var tags = $('input[name="contact[tags]"]', soon); if (tags) tags.value = 'newsletter,notify-place-' + p.slug;
      var f = $('form', soon); if (f) f.addEventListener('submit', function () { try { sessionStorage.setItem(KEY, p.slug); } catch (e) {} });
      soon.hidden = false;
      document.title = p.name + ' on old maps: coming soon';
      var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex, follow'; document.head.appendChild(m);
    });
    function draw() {
      places().then(function (P) {
        var n = (q.value || '').trim().toLowerCase();
        var list = P.list.filter(function (p) { return (show === 'all' || p.live) && (!n || p.name.toLowerCase().indexOf(n) > -1 || (p.county || '').toLowerCase().indexOf(n) > -1); });
        var groups = {};
        list.forEach(function (p) { var g = (COUNTRY[p.country] || 'Elsewhere') + (p.county ? ' · ' + p.county : ''); (groups[g] = groups[g] || []).push(p); });
        var keys = Object.keys(groups).sort();
        out.innerHTML = keys.map(function (g) {
          return '<div class="tt-gaz__group"><h2>' + esc(g) + '</h2><ul class="tt-gaz__list">' + groups[g].sort(function (a, b) { return a.name.localeCompare(b.name); }).map(function (p) {
            return '<li><a href="' + esc(placeUrl(p.slug)) + '">' + esc(p.name) + '</a>' + (p.live ? '<span class="tt-badge tt-badge--live">' + p.products.length + (p.products.length === 1 ? ' map' : ' maps') + '</span>' : '<span class="tt-gaz__county">' + esc(SOON) + '</span>') + '</li>';
          }).join('') + '</ul></div>';
        }).join('') || '<p class="tt-lede">No place by that name yet. <a class="tt-link" href="#tt-newsletter">Ask us for it</a>.</p>';
        var live = list.filter(function (p) { return p.live; }).length;
        count.textContent = list.length + ' places · ' + live + ' in the shop now';
      });
    }
    q.addEventListener('input', draw);
    $$('[data-tt-gaz-show]', root).forEach(function (b) {
      b.addEventListener('click', function () { show = b.dataset.ttGazShow; $$('[data-tt-gaz-show]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); draw(); });
    });
    draw();
  }

  function init() {
    $$('[data-tt-place-search]').forEach(setupSearch);
    $$('[data-tt-near]').forEach(setupNear);
    $$('[data-tt-tabs]').forEach(setupTabs);
    $$('[data-tt-finder]').forEach(setupFinder);
    $$('[data-tt-gazetteer]').forEach(setupGazetteer);
    $$('[data-tt-place-head]').forEach(fillPlaceHead);
    fillSeries();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);   // theme editor
  window.TT = { places: places, slugify: slugify };
})();
